import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 65 65",
  "content": "<symbol viewBox=\"0 0 65 65\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-right\"><path d=\"M44.5 26L50 31.5L44.5 37\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M48 30H16\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" /><path d=\"M48 33H16\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol